module.exports = __webpack_public_path__ + "static/media/30OIOS7.938ed1a2.jpg";